import { defineMessages } from "react-intl";

import {
	diabetesComplicationMessages,
	diabetesTypeMessages,
	hasDiseaseMessages,
	lipoproteinDisturbancesTypeMessages,
	metabolicDiseaseTypeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/metabolicDisease";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	empty: {
		id: "ktx.form.metabolicDisease.emtpy",
		defaultMessage: ""
	},
	metabolicDisease: {
		id: "ktx.form.metabolicDisease.title",
		defaultMessage: "Endokrin és anyagcsere betegség"
	},
	disease: {
		id: "ktx.form.metabolicDisease.type",
		defaultMessage: "Betegség"
	},
	hasDisease: {
		id: "ktx.form.metabolicDisease.hasDisease",
		defaultMessage: "Betegség?"
	},
	diabetesType: {
		id: "ktx.form.metabolicDisease.diabetes.type",
		defaultMessage: "Diabetes típusa"
	},
	lipoproteinDisturbancesType: {
		id: "ktx.form.metabolicDisease.lipoproteinDisturbances.type",
		defaultMessage: "Típusa"
	},
	diabetesComplication: {
		id: "ktx.form.metabolicDisease.diabetes.complication",
		defaultMessage: "Szövődmények"
	},
	comment: {
		id: "ktx.form.metabolicDisease.diabetes.comment",
		defaultMessage: "Megjegyzés"
	}
});

const hasDiseaseField: FieldData = {
	type: "field",
	path: ["hasDisease"],
	label: messages.hasDisease,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: {
			labels: hasDiseaseMessages
		}
	}
};

const diseaseTypeField: FieldData = {
	type: "field",
	path: ["metabolicDiseaseType"],
	label: messages.disease,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: {
			labels: metabolicDiseaseTypeMessages
		}
	}
};

const diabetesTypeField: FieldData = {
	type: "field",
	path: ["diabetesType"],
	label: messages.diabetesType,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: {
			labels: diabetesTypeMessages
		}
	}
};

const diabetesComplicationField: FieldData = {
	type: "field",
	path: ["diabetesComplication"],
	label: messages.diabetesComplication,
	errorMessages: genericErrorMessages,
	input: {
		type: "checkbox-group",
		props: {
			labels: diabetesComplicationMessages,
			direction: "vertical",
			columns: 2
		}
	}
};

const lipoproteinDisturbancesTypeField: FieldData = {
	type: "field",
	path: ["lipoproteinDisturbancesType"],
	label: messages.lipoproteinDisturbancesType,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: {
			labels: lipoproteinDisturbancesTypeMessages
		}
	}
};

const commentField: FieldData = {
	type: "field",
	path: ["comment"],
	label: messages.comment,
	errorMessages: genericErrorMessages,
	input: { type: "textarea", props: {} }
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [{ width: 12, field: hasDiseaseField }]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field-group-list",
						path: ["diseases"],
						label: messages.empty,
						rows: [
							{
								columns: [
									{ width: 12, field: diseaseTypeField }
								]
							},
							{
								columns: [
									{ width: 12, field: diabetesTypeField }
								]
							},
							{
								columns: [
									{
										width: 12,
										field: diabetesComplicationField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: lipoproteinDisturbancesTypeField
									}
								]
							},
							{
								columns: [
									{
										width: 12,
										field: commentField
									}
								]
							}
						]
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_metabolicDisease",
	value: {
		schemaId: "metabolicDisease",
		title: messages.metabolicDisease,
		validator,
		fieldset,
		applyCurrentDate: false,
		initialValue: { metabolicDiseases: [{}] }
	}
};
